import React, { memo } from 'react';
import Navbar from '../components/layout/Navbar';
import HeroSection from '../components/sections/HeroSection';
import Footer from '../components/layout/Footer';
import LogoReleaseSection from '../components/sections/LogoReleaseSection';
import LocationMapsSection from '../components/sections/LocationMapsSection';


const MemoizedNavbar = memo(Navbar);
const MemoizedHeroSection = memo(HeroSection);
const MemoizedLogoReleaseSection = memo(LogoReleaseSection);
const MemoizedLocationMapsSection = memo(LocationMapsSection);
const MemoizedFooter = memo(Footer);

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <MemoizedNavbar />
      <main>
        <MemoizedHeroSection />
        <MemoizedLogoReleaseSection />
        <MemoizedLocationMapsSection />
      </main>
      <MemoizedFooter />
    </div>
  );
};

export default memo(HomePage);